import React from 'react';
import { Helmet } from 'react-helmet';

export default function Meta() {
    return (
        <Helmet>
            <title>Rajeev Pandya - Human Resource Leader | Chief Human Resources Officer</title>
            <meta charSet="utf-8" />
            <meta name="title" content="Rajeev Pandya - Human Resource Leader | Chief Human Resources Officer" />
            <meta name="description"
                content="Rajeev Pandya is a seasoned Human Resource leader, with decades of experience driving HR innovation, workforce development, and organizational transformation. Learn more about his journey." />
            <meta name="author" content="Rajeev Pandya" />
            <meta name="keywords"
                content="Rajeev Pandya, Human Resources, HR Leader, Rajeev Pandya HR, HR Leadership, Chief Human Resources Officer, HR Innovation, Workforce Development, Organizational Transformation, HR Strategy, Geetanjali Group of Colleges, Udaipur" />
            <meta name="robots" content="index, follow" />
            <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="language" content="English" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#004aad" />

            {/* Search Engine */}
            <meta name="image" content="../../assets/Rajeev Pandya.jpg" />

            {/* Schema.org for Google */}
            <meta itemProp="name" content="Rajeev Pandya - Human Resource Leader | Chief Human Resources Officer" />
            <meta itemProp="description"
                content="Rajeev Pandya is a Human Resource expert, specializing in HR strategy, leadership, and organizational growth. His extensive career includes leading HR operations at Geetanjali Group of Colleges, Udaipur." />
            <meta itemProp="image" content="../../assets/Rajeev Pandya.jpg" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Rajeev Pandya - Human Resource Leader | Chief Human Resources Officer" />
            <meta name="twitter:description"
                content="Explore the professional journey of Rajeev Pandya, a top-tier HR leader driving transformation across organizations with a people-first approach." />
            <meta name="twitter:site" content="@RajeevPandya4" />
            <meta name="twitter:creator" content="@RajeevPandya4" />
            <meta name="twitter:image:src" content="/images/logos/raj-pandya-social.png" />

            <script type="application/ld+json">{`
            {
                "@context": "https://schema.org",
                "@type": "Person",
                "name": "Rajeev Pandya",
                "jobTitle": "Chief Human Resources Officer",
                "description": "Rajeev Pandya is a seasoned HR leader with decades of experience in driving HR innovation.",
                "url": "https://rajeevpandya.vercel.app/",
                "image": "../../assets/Rajeev Pandya.jpg",
                "sameAs": [
                    "https://twitter.com/RajeevPandya123",
                    "https://www.facebook.com/RajeevPandyaMotivationalSpeak/"
                ]
            }
            `}</script>

            {/* Open Graph general (Facebook, Pinterest & Google+) */}
            <meta property="og:title" content="Rajeev Pandya - Human Resource Leader | Chief Human Resources Officer" />
            <meta property="og:description"
                content="Rajeev Pandya is a seasoned HR leader, recognized for his strategic approach in workforce development, HR innovation, and organizational transformation." />
            <meta property="og:image" content="../../assets/android-chrome-192x192.png" />
            <meta property="og:url" content="https://www.facebook.com/RajeevPandyaMotivationalSpeak/" />
            <meta property="og:site_name" content="Rajeev Pandya - Personal HR Facebook" />
            <meta property="og:locale" content="en_IN" />
            <meta property="og:type" content="website" />

            <link rel="icon" href="/images/logos/raj-pandya-favicon.svg" />
            <link rel="apple-touch-icon" href="../../assets/Rajeev Pandya.jpg" />
            <link rel="preload" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" as="style" />
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet" />
        </Helmet>
    );
}
